export const MEDIA_DOWNLOAD_FEATURE = 'media-download';
